import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable, observableCombineLatest, rx } from '@shared/rx';
import { environment } from '../../../../environments/environment';
import { XUXDrawerSidebarService } from '@xenial-ux/services';
import { XprtDataActions, SessionActions } from '@store/actions';
import { ICompany } from '@app/shared/types';

@Component({
  selector: 'xvi-main-header',
  styleUrls: ['main-header.style.scss'],
  templateUrl: 'main-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainHeaderComponent implements OnInit {
  public buildVersion: string = environment.version;
  public selectedCompany$: Observable<any>;
  public infoRoute: string = 'detailed-info';

  @select(['userSession', 'user']) public user$: Observable<any>;
  @select(['userSession', 'companies']) private companies$: Observable<
    ICompany[]
  >;
  @select(['userSession', 'currentCompanyId'])
  private currentCompanyId$: Observable<string>;

  public constructor(
    private xprtDataActions: XprtDataActions,
    private sessionActions: SessionActions,
    private xuxDrawerSidebarService: XUXDrawerSidebarService,
  ) {}

  public ngOnInit(): void {
    this.selectedCompany$ = observableCombineLatest([
      this.companies$,
      this.currentCompanyId$,
    ]).pipe(
      rx.map(([companies, currentCompanyId]: [ICompany[], string]) =>
        companies.find((company) => company.id === currentCompanyId),
      ),
      rx.share(),
    );
  }

  public showCompanySelector(): void {
    this.xprtDataActions.showCompanySelector();
  }

  public logout(): void {
    this.xuxDrawerSidebarService.close();
    this.sessionActions.logoutUser();
  }
}
